<template>
  <v-container class="fill-height pb-0" >
    <v-card class="e-cardLeccion-final e-elevation--4 e-border--radius fill-height">
      <v-card-title class="e-cardLeccion-final-title verde pb-0 justify-center">
        <div class="">
          <img src="../../../../assets/images/gramatica/inicioleccion.png" alt="Personaje leccion" class="pb-2"/>
        </div>
      </v-card-title>
      <v-card-text class="e-cardLeccion-final-text px-4 align-start d-flex justify-end">
        <div class="pt-3">
          <h4 class="e-subTitle grey-light--text text-xs-center">En esta lección aprenderás:</h4>
          <p class="e-description-big mb-0 mt-2">{{ descripcion }}</p>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    descripcion: {
      type: String,
      default: '‘ㄷ’'
    }
  }
}
</script>
